import { actionTypes } from '@/context/actionTypes';
import { createContext } from '@/context/createContext';
import { commonAction } from '@/types/commonActions';

export type statusTrackingDataType = {
  requestStatus: 'professionalInTransit' | 'serviceCompleted' | '';
};

export type statusTrackingDispatchType = {
  setRequestStatus: Function;
};

const initialState: statusTrackingDataType = {
  requestStatus: '',
};
export function statusReducer(state: statusTrackingDataType, action: commonAction) {
  const { requestStatus = initialState.requestStatus }: statusTrackingDataType = action.payload;
  switch (action.type) {
    case actionTypes.SET_STATUS: {
      return {
        ...state,
        requestStatus: requestStatus,
      };
    }
    default:
      throw new Error(`Unsupported type: ${action.type}`);
  }
}

const setRequestStatus = (dispatch: any) => (activeTab: string) => {
  dispatch({ type: actionTypes.SET_STATUS, payload: { requestStatus: activeTab } });
};

const { Context: StatusTrackingContext, Provider: StatusTrackingProvider } = createContext<
  statusTrackingDataType,
  statusTrackingDispatchType
>(
  statusReducer,
  {
    setRequestStatus,
  },
  initialState,
);

StatusTrackingContext.displayName = 'StatusTracking';

export { StatusTrackingContext, StatusTrackingProvider };
